import { Icon } from './Icon';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  action?: { label: string; onClick?: () => void };
}

export function PageHeader({ title, subtitle, action }: PageHeaderProps) {
  const label = action?.label.replace(/^\+\s*/, '');
  return (
    <div className="page-header">
      <div>
        <h1>{title}</h1>
        {subtitle && <p>{subtitle}</p>}
      </div>
      {action && (
        <button type="button" className="btn btn-primary" onClick={action.onClick}>
          <Icon name="plus" size={15} />
          {label}
        </button>
      )}
    </div>
  );
}
